import React from 'react';
import { arrayOf, string, number, shape } from 'prop-types';
import {
  Image, Table, TableBody, TableHead, TableRow
} from '@thd-olt-component-react/core-ui';
import styles from './article-section.module.scss';

const BUYING_GUIDE = 'ab';
const ComparisonTable = ({ fields, articleType }) => {
  const fieldDescriptions = fields.map((field) => field.description);
  const shouldDisplayDescriptions = !fieldDescriptions.every((field) => !field);
  const products = fields.map((field) => field.product);
  if (articleType !== BUYING_GUIDE) return null;
  return (
    <Table name="ComparisonTable" className={styles['article-sections__comparison-table']}>
      <TableHead />
      <TableBody>
        <TableRow classNames={styles['article-sections__comparison-table-tr']}>
          {products.map(({ image, title, url }, index) => {
            return (
              <td
                key={index}
                className={styles['article-sections__comparison-table-td1']}
                style={{ textAlign: 'center !important' }}
              >
                <a href={url}>
                  <Image
                    src={image}
                    alt={title || 'product'}
                    title={title}
                    width={180}
                    height={180}
                  />
                </a>
                <div className={styles['article-sections__comparison-table-title']}>
                  {title}
                </div>
              </td>
            );
          }
          )}
        </TableRow>
        {
          shouldDisplayDescriptions
          && (
            <TableRow classNames={styles['article-sections__comparison-table-tr']}>
              {fieldDescriptions.map((field, index) => {
                return (
                  <td key={field + index} className={styles['article-sections__comparison-table-td2']}>
                    {field}
                  </td>
                );
              })}
            </TableRow>
          )
        }

      </TableBody>

    </Table>
  );

};

ComparisonTable.propTypes = {
  fields: arrayOf(shape({
    description: string,
    product: arrayOf(shape({
      description: string,
      id: string,
      image: string,
      quantity: number,
      title: string,
      url: string,
    })),
  })),
  articleType: string
};

ComparisonTable.defaultProps = {
  articleType: '',
  fields: [],
};
export { ComparisonTable };
